/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import QRScanner from 'react-qr-scanner'; // Importa el componente QRScanner
import '../styles/ingreso.css';
import { useAuth } from '../context/AuthContext';

function Movimiento3Page() {
  const { token } = useAuth();
  const { scanCode, scanCode2 } = useParams(); // Obtén el primer y segundo scanCode desde la URL
  const [isScannerReady, setIsScannerReady] = useState(true);  // Iniciar el escáner cuando el componente se carga
  const navigate = useNavigate();

  useEffect(() => {
    // Configurar un retraso para iniciar el escáner si es necesario
    const timer = setTimeout(() => {
      setIsScannerReady(true);  // Activar el escáner
    }, 1000); // Ajusta el tiempo según necesites

    return () => {
      clearTimeout(timer);  // Limpiar el temporizador si el componente se desmonta antes de lo esperado
    };
  }, []);

  const handleScan = (data) => {
    if (data) {
      console.log('Código QR escaneado:', data.text);

      // Detener el escáner después de escanear
      setIsScannerReady(false);

      // Navegar a la nueva página con los tres códigos escaneados
      navigate(`/storage/movimiento/${scanCode.trim()}/${scanCode2.trim()}/${data.text.trim()}`);
    }
  };

  const handleError = (error) => {
    console.error('Error al escanear:', error);
  };

  return (
<div className="qrscanner-container">
  <button 
    onClick={() => navigate(`/storage/movimiento/${scanCode.trim()}`)} 
    className="qrscanner-back-button"
  >
    &#8592;
  </button>

  <h1 className="qrscanner-title">Escanea ubicación donde quieres agregar producto</h1>

  <div className="qrscanner-video-container">
    {isScannerReady && (
      <QRScanner
        delay={300}  // Tiempo de retraso entre cada escaneo
        onScan={handleScan}  // Llamar a handleScan cuando se escanee un código
        onError={handleError}  // Llamar a handleError si ocurre un error
        style={{ width: '100%', height: '100%' }} // Asegúrate de que el video ocupe todo el contenedor
        constraints={{
          video: {
            facingMode: 'environment', // Fuerza la cámara trasera
          },
        }}
      />
    )}
  </div>
</div>

  );
}

export default Movimiento3Page;
